import * as React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { mediaStore } from './redux';

import FiltersComponent from './components/filters';
import GalleryListingComponent from './components/gallery-listing';
import ModalComponent from './components/modal';

render(
    <Provider store={mediaStore}>
        <div>
            <ModalComponent />
            <FiltersComponent />
            <GalleryListingComponent />
        </div>
    </Provider>

    , document.getElementById("media-gallery-entry-js"));


// WEBPACK FOOTER //
// ./app/media-gallery/index.tsx